import { render, staticRenderFns } from "./FantasyWordContainer.vue?vue&type=template&id=772388c0&scoped=true"
import script from "./FantasyWordContainer.vue?vue&type=script&lang=ts"
export * from "./FantasyWordContainer.vue?vue&type=script&lang=ts"
import style0 from "./FantasyWordContainer.vue?vue&type=style&index=0&id=772388c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772388c0",
  null
  
)

export default component.exports